import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react-lite';
import { UpliftThemeProvider } from '@uplift/ui-v2';
import { UserSessionInfoCard } from '../../components';
import { Appointment, CurrentUser } from '@uplift/api';

export type HungUpPageProps = {
  me: CurrentUser;
  appointment: Pick<Appointment, 'id' | 'fromDatetime' | 'toDatetime' | 'patientId' | 'providerId'>;
  reEnterCall: () => void;
  completeSession: (sessionId: string) => void;
};

export const HungUpPage: React.FC<HungUpPageProps> = observer(({ appointment, reEnterCall, completeSession }) => {
  const { classes } = useStyles();

  return (
    <UpliftThemeProvider>
      <Box display="flex">
        <Box className={classes.container}>
          <UserSessionInfoCard appointment={appointment} reEnterCall={reEnterCall} completeSession={completeSession}/>
        </Box>
      </Box>
    </UpliftThemeProvider>
  );
});

const useStyles = makeStyles()((theme) => ({
  container: {
    // 792px
    maxWidth: theme.spacing(99),
    margin: '0 auto',
    marginTop: theme.spacing(8.5),
    padding: theme.spacing(0, 2),
  }
}));
